import './styles.scss'
import cx from 'classnames'

interface CircularProgressProps {
  className?: string
  type?: 'big' | 'tiny' | 'small' | 'full-width-circular-progress'
  color?: string
  style?: React.CSSProperties
}

export function CircularProgress ({ className, color, style, type }: CircularProgressProps): JSX.Element {
  const spinnerCls = `spinner-layer spinner-${color ?? 'blue'}-only`

  return (
    <div
      className={cx('preloader-wrapper', 'active', type ?? 'big', className)}
      style={style}
      data-cy='preloader'
    >
      <div
        className={spinnerCls}
      >
        <div className='circle-clipper left'>
          <div className='circle' />
        </div>
        <div className='gap-patch'>
          <div className='circle' />
        </div>
        <div className='circle-clipper right'>
          <div className='circle' />
        </div>
      </div>
    </div>
  )
}

export function FullWidthCircularProgress (): JSX.Element {
  return (
    <div className='full-width-circular-progress-backdrop'>
      <CircularProgress type='full-width-circular-progress' />
    </div>
  )
}
